(function () {
    'use strict';

    angular
            .module('jotApp')
            .directive('fileTypesFilter', fileTypesFilter);

    function fileTypesFilter() {
        var directive = {
            restrict: 'E',
            scope: {
                filter: '&',
                tabFileType: '&',
                tabObjectType: '&',
                tabFileTypeVal: '&',
                tabObjectTypeVal: '&'
            },
            template:
            '<div class="row">\n' +
            '    <div class="col-xs-12">\n' +
            '        <div class="portlet light filter-portlet bordered">\n' +
            '            <div class="portlet-body form">\n' +
            '                <form ng-submit="vm.submit()" class="horizontal-form">\n' +
            '                    <div class="form-body">\n' +
            '                        <div class="row">\n' +
            '                            <div class="col-xs-5">' +
            '                                <div class="form-group">\n' +
            '                                   <label class="control-label ng-scope" for="objectType_field">Object Type</label>\n' +
            '                                   <ui-select ng-model="vm.tabObjectType" id="objectType_field" theme="bootstrap">\n' +
            '                                        <ui-select-match placeholder="Select or search an object type..."> {{$select.selected.objectTypeName}} </ui-select-match>\n' +
            '                                        <ui-select-choices repeat="item in vm.objectTypes | filter: {objectTypeName: $select.search}">\n' +
            '                                           <div ng-bind-html="item.objectTypeName | highlight: $select.search"></div>\n' +
            '                                        </ui-select-choices>\n' +
            '                                    </ui-select>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                            <div class="col-xs-5">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label for="field_fileType">File Type</label>\n' +
            '                                    <ui-select ng-model="vm.tabFileType" id="fileType_field" theme="bootstrap">\n' +
            '                                       <ui-select-match\n' +
            '                                           placeholder="Select or search a file type...">\n' +
            '                                           {{$select.selected.fileTypeName}}\n' +
            '                                       </ui-select-match>\n' +
            '                                       <ui-select-choices repeat="item in vm.tabFileTypes | filter: {fileTypeName: $select.search}">\n' +
            '                                           <div ng-bind-html="item.fileTypeName | highlight: $select.search"></div>\n' +
            '                                       </ui-select-choices>\n' +
            '                                       </ui-select>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                            <div class="col-xs-2 inline-filter-button">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label class="control-label ng-scope" for="submit_field"></label>\n' +
            '                                    <button type="submit" id="submit_field" class="btn btn-primary">\n' +
            '                                        <span class="fa fa-filter"></span>&nbsp;<span translate="entity.action.filter">Filter</span>\n' +
            '                                    </button>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                       </div>\n' +
            '                    </div>\n' +
            '                </form>\n' +
            '            </div>\n' +
            '        </div>\n' +
            '    </div>\n' +
            '</div>\n',
            controller: FileTypesFilterController,
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;
    }

    FileTypesFilterController.$inject = ['TabFileTypes', 'TabObjectTypes'];

    function FileTypesFilterController(TabFileTypes, TabObjectTypes){
        var vm=this;
        TabFileTypes.query({size: 1000}, onSuccess, onError);
        TabObjectTypes.query({size:1000}, onSuccessTypes, onErrorTypes);


        function onSuccessTypes(data) {
            vm.objectTypes = data;
            vm.objectTypes.unshift(allObjectTypes);
        }

        function onErrorTypes() {}

        function onSuccess(data) {
            vm.tabFileTypes = data;
            vm.tabFileTypes.unshift(allFileTypes);
        }

        function onError() {}

        var allFileTypes = {
            id: -1,
            fileTypeName: "All"
        };

        var allObjectTypes = {
            id: -1,
            objectTypeName: "All"
        };

        vm.tabFileType = +vm.tabFileTypeVal() === -1 || +vm.tabFileTypeVal().id === -1 ? allFileTypes : vm.tabFileTypeVal();
        vm.tabObjectType = +vm.tabObjectTypeVal() === -1 || +vm.tabFileTypeVal().id === -1 ? allObjectTypes : vm.tabObjectTypeVal();

        vm.submit = function () {
            if(vm.tabObjectType.id == -1){
                TabFileTypes.query({size: 1000}, onSuccess, onError);
                vm.filter({
                    tabFileType: vm.tabFileType,
                    tabObjectType: vm.tabObjectType
                });
            } else {
                TabObjectTypes.get({id: vm.tabObjectType.id}, onSuccessTypesId, onErrorTypesId);
            }

            function onSuccessTypesId(data) {
                vm.tabFileTypes = data.fileTypes;
                vm.tabFileTypes.unshift(allFileTypes);
                vm.filter({
                    tabFileType: vm.tabFileType,
                    tabObjectType: vm.tabObjectType
                });
            }

            function onErrorTypesId() {}
        };
    }


})();
